import React, { useEffect, useRef } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    Typography,
    Slide,
    Paper,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Icon } from '@iconify/react/dist/iconify.js';
import { ErrorMessage, Formik, Form } from 'formik';
import SearchableDropdown from '../../../../components/SearchableDropdown';
import { addStatesValidation } from '../../../../validationSchema/SocietyController/Location/locationSchema';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { createState, getCountries } from '../../../../redux/actions/SocietyController/CtrlLocationAction/CtrlLocationAction';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const AddStateModal = ({ getStateTableData, open, handleClose, editData = null }) => {
    const formRef = useRef(null);
    const dispatch = useDispatch();
    const { createLoading } = useSelector(state => state.CtrlLocationReducers);
    const { countryData } = useSelector(state => state.CtrlLocationReducers)

    const handleSaveClick = () => {
        // Trigger form submission via ref
        formRef.current?.handleSubmit();
    }
    const params = {
        page: 1,
        limit: 10,
        search: '',
        status: true
    };
    useEffect(() => {
        dispatch(getCountries(params))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Formik
            initialValues={{
                name: editData?.name || '',
                country_id: editData?.country_id || '',
                state_code: editData?.state_code || '',
            }}
            enableReinitialize={true}
            validationSchema={addStatesValidation()}
            onSubmit={(values, { resetForm, setSubmitting }) => {
                console.log(values, 'state values')
                dispatch(createState({
                    ...values,
                    onSuccess: () => {
                        getStateTableData()
                        handleClose();
                        resetForm();
                    }
                }));
                setSubmitting(false);
            }}
            innerRef={(f) => (formRef.current = f)}
        >
            {(formik) => (
                <Form>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        TransitionComponent={Transition}
                        maxWidth="sm"
                        fullWidth
                        PaperProps={{
                            sx: {
                                borderRadius: 3,
                                overflow: 'hidden',
                            }
                        }}
                    >
                        {/* Header with Gradient Background */}
                        <Box
                            sx={{
                                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                color: 'white',
                                position: 'relative',
                            }}
                        >
                            {/* Background Pattern */}
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    opacity: 0.1,
                                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                                }}
                            />

                            <DialogTitle sx={{ p: 2.5, pb: 2 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                        <Box
                                            sx={{
                                                width: 40,
                                                height: 40,
                                                borderRadius: 2,
                                                backgroundColor: 'rgba(255,255,255,0.2)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <Icon icon="mdi:flag" width={24} height={24} />
                                        </Box>
                                        <Box>
                                            <Typography variant="h6" sx={{ fontWeight: 600, color: 'white', fontSize: '1.1rem' }}>
                                                {editData ? 'Edit State' : 'Add New State'}
                                            </Typography>
                                            <p className='tw-text-white tw-text-sm'>
                                                {editData ? 'Update state information' : 'Add a new state to the system'}
                                            </p>
                                        </Box>
                                    </Box>
                                    <IconButton
                                        aria-label="close"
                                        onClick={handleClose}
                                        size="small"
                                        sx={{
                                            color: 'white',
                                            backgroundColor: 'rgba(255,255,255,0.15)',
                                            '&:hover': {
                                                backgroundColor: 'rgba(255,255,255,0.25)',
                                            },
                                        }}
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </Box>
                            </DialogTitle>
                        </Box>

                        <DialogContent sx={{ p: 0, bgcolor: '#f8fafc' }}>
                            <Box sx={{ p: 2.5 }}>
                                <Paper
                                    elevation={0}
                                    sx={{
                                        p: 2.5,
                                        borderRadius: 2,
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        backgroundColor: 'background.paper',
                                    }}
                                >
                                    {/* Country Selection */}
                                    <Box sx={{ mb: 2.5 }}>
                                        <Typography
                                            variant="body2"
                                            sx={{ fontWeight: 600, color: 'text.secondary', mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}
                                        >
                                            <Icon icon="mdi:earth" width={16} />
                                            Country <span style={{ color: '#ef4444' }}>*</span>
                                        </Typography>
                                        <SearchableDropdown
                                            value={formik.values.country_id ? String(formik.values.country_id) : 'all'}
                                            onChange={(v) => formik.setFieldValue('country_id', v === 'all' ? '' : v)}
                                            options={[
                                                { value: 'all', label: 'Select country' },
                                                ...((countryData?.data || []).map((item) => ({
                                                    value: String(item.country_id),
                                                    label: item.name,
                                                }))),
                                            ]}
                                            placeholder="Select country"
                                            clearable={false}
                                        />
                                        <div className="text-danger text-sm italic h-4 text-wrap break-words">
                                            <ErrorMessage name="country_id" />
                                        </div>
                                    </Box>

                                    {/* State Name */}
                                    <Box sx={{ mb: 2.5 }}>
                                        <Typography
                                            variant="body2"
                                            sx={{ fontWeight: 600, color: 'text.secondary', mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}
                                        >
                                            <Icon icon="mdi:flag" width={16} />
                                            State Name <span style={{ color: '#ef4444' }}>*</span>
                                        </Typography>
                                        <input
                                            type="text"
                                            name="name"
                                            value={formik.values.name}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className="form-control radius-8"
                                            placeholder="Enter state name"
                                            style={{ fontSize: '0.875rem' }}
                                        />
                                        <div className="text-danger text-sm italic h-4 text-wrap break-words">
                                            <ErrorMessage name="name" />
                                        </div>
                                    </Box>

                                    {/* State Code */}
                                    <Box>
                                        <Typography
                                            variant="body2"
                                            sx={{ fontWeight: 600, color: 'text.secondary', mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}
                                        >
                                            <Icon icon="mdi:alphabetical" width={16} />
                                            State Code <span style={{ color: '#ef4444' }}>*</span>
                                        </Typography>
                                        <input
                                            type="text"
                                            name="state_code"
                                            value={formik.values.state_code}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className="form-control radius-8"
                                            placeholder="e.g., CA, TX, MH"
                                            maxLength={3}
                                            style={{ fontSize: '0.875rem', textTransform: 'uppercase' }}
                                        />
                                        <div className="text-danger text-sm italic h-4 text-wrap break-words">
                                            <ErrorMessage name="state_code" />
                                        </div>
                                    </Box>

                                </Paper>
                            </Box>
                        </DialogContent>

                        {/* Actions */}
                        <DialogActions sx={{ px: 2.5, py: 2, borderTop: '1px solid', borderColor: 'divider', gap: 1.5, bgcolor: 'white' }}>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="btn btn-outline-secondary radius-8 px-20 py-10 text-sm fw-medium"
                                disabled={createLoading}
                                style={{ flex: 1 }}
                            >
                                <Icon icon="solar:close-circle-outline" className="me-6" />
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-success radius-8 px-20 py-10 text-sm fw-medium"
                                disabled={createLoading}
                                onClick={handleSaveClick}
                                style={{ flex: 1, backgroundColor: '#22c55e', borderColor: '#22c55e' }}
                            >
                                {createLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-8" role="status" aria-hidden="true"></span>
                                        Saving...
                                    </>
                                ) : (
                                    <>
                                        <Icon icon="solar:check-circle-bold" sx={{ fontSize: '1.5rem', mr: 0.75 }} />
                                        {editData ? 'Update State' : 'Save State'}
                                    </>
                                )}
                            </button>
                        </DialogActions>
                    </Dialog>
                </Form>
            )}
        </Formik>
    );
};

export default AddStateModal;
